import type { ReactNode } from 'react';

/** Cartao de um grafico: titulo, uma linha dizendo o que ele mostra, e acoes (ex.: trocar a metrica). */
export function CartaoGrafico({
  titulo,
  sub,
  acoes,
  nota,
  children,
}: {
  titulo: string;
  sub?: ReactNode;
  acoes?: ReactNode;
  /** Ressalva embaixo (ex.: o que ficou de fora). */
  nota?: ReactNode;
  children: ReactNode;
}) {
  return (
    <section className="min-w-0 rounded-(--radius-painel) border border-borda bg-superficie px-4 pt-4 pb-3.5 shadow-cartao sm:px-5">
      <div className="flex flex-wrap items-start justify-between gap-3">
        <h2 className="text-[15px] font-semibold">{titulo}</h2>
        {acoes}
      </div>
      {sub && <p className="mt-0.5 mb-3.5 text-xs leading-relaxed text-apagado">{sub}</p>}
      {children}
      {nota && <p className="mt-3 text-[11.5px] leading-relaxed text-apagado">{nota}</p>}
    </section>
  );
}
